import HomeSearchBox from './homeSearchBox';
import InstantSearchProvider, {
  InstantSearchConfig,
} from '@javascript/instant_search/provider/instantSearchProvider';
import { useStats } from 'react-instantsearch';
import { delimitWithCommas } from '@javascript/lib/utils';

const NumberOfCars = () => {
  const { nbHits } = useStats();

  if (nbHits === 0) return null;

  return (
    <p className="ac-instant-search-homepage__count ch-fs--3 ch-color--white ch-fw--500 ch-text--center">
      Browse {delimitWithCommas(nbHits)} cars in seconds
    </p>
  );
};

const HomeInstantSearch = (props: InstantSearchConfig) => {
  return (
    <div>
      <InstantSearchProvider {...props}>
        <NumberOfCars />
        <HomeSearchBox />
        <span className="ac-instant-search-homepage__divider ch-text-divider ch-bc--grey-6 ch-fw--400 text-divider ch-mv--3 sm:ch-mv--5 ch-color--grey-4 ch-ph--4 sm:ch-ph--2 ch-mh--auto">
          Or
        </span>
        <div className="ch-display--flex ch-justify-content--center">
          <a
            className="ch-btn ch-btn--success ch-mb--5 instant-search-homepage__filter-button"
            data-gtm-track="click_cta"
            data-gtm-track-label="Instant search - homepage - Search using filters"
            href="/vehicles?dialog=open"
            type="button"
          >
            Search using filters
          </a>
        </div>
      </InstantSearchProvider>
    </div>
  );
};

export default HomeInstantSearch;
